import "../assets/XClose.css";
import { defineComponent as m, openBlock as a, createElementBlock as c, withModifiers as p, unref as o, createVNode as f } from "vue";
import { d } from "./debounce.F9gDQpy6.js";
import { i as u } from "./CrossIcon.CBGTWrUp.js";
import { c as g } from "./maps.BMuTsKez.js";
import { l as _ } from "./useStore.Ct_0CDaW.js";
const w = /* @__PURE__ */ m({
  __name: "XClose",
  props: {
    triggerDismiss: { type: Boolean, default: !0 }
  },
  setup(i) {
    const n = _(), l = i, e = d(() => {
      var t;
      l.triggerDismiss === !0 && ((t = n.handlers) == null || t.callHandler(g.Dismiss));
    }, 200, { leading: !0, trailing: !1 });
    return (t, s) => (a(), c("div", {
      class: "thn--tool-xclose",
      onMousedown: s[0] || (s[0] = p(
        //@ts-ignore
        (...r) => o(e) && o(e)(...r),
        ["left"]
      )),
      onClick: s[1] || (s[1] = //@ts-ignore
      (...r) => o(e) && o(e)(...r))
    }, [
      f(o(u), { class: "thn--tool-xclose__svg" })
    ], 32));
  }
});
export {
  w as _
};
//# sourceMappingURL=XClose.vue_vue_type_style_index_0_lang.Bcjbo7wo.js.map
